import $ from 'jquery';
import * as debounce from '../tools/debounce.js';

export const init = () => {

	let submitSomeForm = (formElement) => {
		formElement.submit();
	};

	let debouncedSubmit = debounce(submitSomeForm, 750);	

	$(document)
		.on('input', '.js-input-debounced-submit', function() {
			var $field = $(this);
			var $form = $field.closest('form');
			debouncedSubmit($form);
		})




	


};
